export default __webpack_public_path__ + "static/media/0111.7184fa33.jpg";